// extracted by mini-css-extract-plugin
export default {"total":"ListSessionsCardSelect_total__Z60ho","totalNumber":"ListSessionsCardSelect_totalNumber__yfTSY"};